"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
const RESOURCE = 'user/table/entry/object';
class ObjectService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        this.getAll = async (page = 1, filters = [], size = 10) => {
            let URL = `${environment_1.API_URL_BASE}/${this.ENV}/${RESOURCE}?page=${page}&size=${size}`;
            for (let items of filters) {
                let filter = items;
                for (const key in filter) {
                    let keyFilter = key;
                    URL += `&${key}=${filter[keyFilter]}`;
                }
            }
            const response = await axios_1.default.get(URL, { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.ObjectService = ObjectService;
